import {
  Vue, Component, Prop,
} from 'vue-property-decorator';

import style from './index.module.scss';

@Component({ name: 'RiskTips' })
export default class RiskTips extends Vue {
  /** 风险提示文案 */
  @Prop(String) readonly text!: string;

  @Prop(Boolean) readonly isRechargeAppMarket!: boolean;

  private render() {
    return (
      <div class={style['risk-tips-wrapper']}>
          <div class={this.isRechargeAppMarket ? style['recharge-brand-badge'] : style['brand-badge']}></div>
          <div class={style.text} v-html={this.text}></div>
      </div>
    );
  }
}
